import { render, staticRenderFns } from "./whProductStock.vue?vue&type=template&id=10f1731a&scoped=true&"
import script from "./whProductStock.vue?vue&type=script&lang=js&"
export * from "./whProductStock.vue?vue&type=script&lang=js&"
import style0 from "./whProductStock.vue?vue&type=style&index=0&id=10f1731a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f1731a",
  null
  
)

export default component.exports